<button type="button"
        #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        (click)="openOverlay()"
        class="mimic-mat-select-field w-100"
        [ngClass]="{'color--gray--005' : selectedTagCategoryIds.length}">
  <span class="d-block truncate">
    {{selectedTagCategoryIds.length ? selectedTagCategoryIds.length + ' fields selected' : 'Select fields&hellip;'}}
  </span>
  <div class="mat-select-arrow-wrapper">
    <div class="mat-select-arrow"></div>
  </div>
</button>

<div class="mt-0025 mb-0075 ab-list-group-wrap--with-border"
     *ngIf="selectedTagCategoryIds?.length > 0">
  <div style="max-height: 288px; overflow-y: auto">
    <mat-list class="ab-list-group ab-list-group--qb-selected-tags pt-0">
      <mat-list-item class="ab-list-item bg-color--white p-0075"
                         style="min-height:50px;"
                         *ngFor="let tagCategory of selectedTagCategories; let i = index">
        <i class="fal {{getTagIcon(tagCategory.allowToCreateTagType)}} pt-0025 color--turq mr-0050"></i>
        <ng-container >
          <i class="fal fa-solar-system pt-0025 color--purple mr-0050"
             matTooltip="This is a universal field; responses belonging to this field are available across all campaigns for which this field is enabled."
             *ngIf="tagCategory.isUniversal"></i>
        </ng-container>
        <div class="normal-wrap"
             style="max-width:calc(100% - 100px)">
          <strong>{{tagCategory.groupName}}</strong> &rsaquo; {{tagCategory.name}}
        </div>
        <div class="ml-auto">
          <button mat-icon-button
                  [disabledRipple]="true"
                  (click)="removeCategory(tagCategory)"
                  aria-label="Remove field"
                  class="remove-item">
            <mat-icon fontSet="far"
                      fontIcon="fa-times"></mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="clear-selected-fields-wrap">
    <div>
      <button class="link link--small"
              type="button"
              (click)="showMoreClicked()"
              *ngIf="this.selectedTagCategoryIds.length > this.limit">Show more...</button>
    </div>
    <button class="link link--noline p-0 color--red txt-14"
            (click)="clearSelectedTagCategoryIdsClicked()">Clear all selected fields</button>
  </div>
</div>

<ng-template cdkConnectedOverlay
             (detach)="isOpen = false"
             (backdropClick)="closeOverlay()"
             [cdkConnectedOverlayPush]="true"
             [cdkConnectedOverlayHasBackdrop]="true"
             [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
             [cdkConnectedOverlayHeight]="300"
             [cdkConnectedOverlayMinHeight]="'300px'"
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayWidth]="triggerWidth$ | async"
             [cdkConnectedOverlayMinWidth]="'300px'"
             [cdkConnectedOverlayOpen]="isOpen">
  <app-field-search-inline [campaignId]="campaignId"
                           [targetType]="targetType"
                           [withTypeSelect]="true"
                           [multiple]="true"
                           [selectedOptions]="tagCategoryIdsMapped(selectedTagCategoryIds)"
                           (selectedOptionsChange)="selectedTagCategoryIdsChanged($event)"
                           class="scrollable-quicksearch--wrapper d-block w-100 b-shadow--large"></app-field-search-inline>
</ng-template>
